import classNames from 'classnames/bind';
import styles from './DeleteAccount.module.css';
import Delete from '../Delete';
import { useGetAccountDeleteQuery } from '../../../../services/settings';

export default function DeleteAccount() {
  const cx = classNames.bind(styles);

  const { data, isLoading } = useGetAccountDeleteQuery();

  if (isLoading || !data) return null;

  return <Delete data={data} />;
}
